import { ArrowUpRight } from 'lucide-react';

import { TypographyH6 } from '@/components/ui/typography';
import { env } from '@/config/env';
import { useStore } from '@/stores';
import { useBannerAnnouncementStore } from '@/stores/banner-announcement';

export const SandboxNoticeBar = () => {
  const bannerHeight = useBannerAnnouncementStore((s) => s.bannerHeight);
  const isProtectedRoute = useStore((s) => !!s.accessToken);

  if (env.sandboxMode !== 'true') return null;

  return (
    <div
      className={`fixed inset-x-0 z-[60] flex h-9 w-full justify-center ${
        isProtectedRoute ? 'bg-brand-light-blue' : 'bg-transparent'
      }`}
      style={{ top: bannerHeight }}
    >
      <div className="bg-error absolute inset-x-0 top-0 h-[3px]" />
      <TypographyH6 className="bg-error flex items-center gap-1.5 rounded-b-lg px-2.5 py-1.5 text-xs tracking-normal whitespace-nowrap text-white shadow-md sm:gap-3 sm:px-4 sm:text-base">
        You&apos;re in Sandbox Mode.
        <a
          href={env.productionDashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-0.5 underline underline-offset-2 hover:opacity-80"
        >
          Move to Production
          <ArrowUpRight className="h-3 w-3 sm:h-3.5 sm:w-3.5" />
        </a>
      </TypographyH6>
    </div>
  );
};
